export default __webpack_public_path__ + "static/media/availibility.aefd3b11.svg";